import { slackAppStoreUrl } from "@clockwise/client-commons/src/constants/site";
import React, { useEffect, useState } from "react";
import { useFeatureFlag } from "../../../../launch-darkly";
import { TrackingEvents, track } from "../../../../util/analytics.util";
import { useWebOnboardingSteps } from "../../hooks/useWebOnboardingSteps";
import { ButtonGroup, StepCounter, StepLayout } from "../../shared-components";
import { InstallConfirmation } from "./InstallConfirmation";
import { RecommendedApps } from "./RecommendedApps";
import { SlackSlide } from "./SlackSlide";

export const SlackStep = () => {
  const { goForward, goBack, shouldShowSecondaryButton, funnelType } = useWebOnboardingSteps();
  const [isOnAIOnboarding] = useFeatureFlag("rollout-ai-onboarding");

  const [showSlackComplete, setShowSlackComplete] = useState(false);

  useEffect(() => {
    track(TrackingEvents.WEB_ONBOARDING.SLACK_STEP_VIEWED, { funnelType });
  }, []);

  const openSlackAndGoForward = () => {
    track(TrackingEvents.WEB_ONBOARDING.SLACK_STEP_CLICK_INSTALL, { funnelType });

    if (isOnAIOnboarding) {
      goForward();
      setTimeout(() => window.open(slackAppStoreUrl, "_blank"), 100);
    } else {
      window.open(slackAppStoreUrl, "_blank");
      setShowSlackComplete(true);
    }
  };

  const skipStep = () => {
    track(TrackingEvents.WEB_ONBOARDING.SLACK_STEP_SKIPPED, { funnelType });
    goForward();
  };

  const InstallSlack = () => {
    return (
      <>
        <SlackSlide />
        <ButtonGroup
          shouldShowSkip
          shouldShowSecondary={shouldShowSecondaryButton}
          primaryLabel={"Install Slack App"}
          onClickPrimary={openSlackAndGoForward}
          onClickSecondary={goBack}
          onSkip={skipStep}
        />
      </>
    );
  };

  const InstallComplete = () => {
    return (
      <>
        <InstallConfirmation />
        <RecommendedApps goForward={goForward} />
        <ButtonGroup
          shouldShowSecondary={false}
          primaryLabel={"Continue to Clockwise"}
          onClickPrimary={goForward}
          onClickSecondary={goBack}
        />
      </>
    );
  };

  return (
    <StepLayout>
      <StepCounter />
      {showSlackComplete ? <InstallComplete /> : <InstallSlack />}
    </StepLayout>
  );
};
